import { Injectable } from "@angular/core";
import type { Resolve } from "@angular/router";
import { NodeSharedFacade } from '@medsurf/flat-facades';

@Injectable({
  providedIn: "root"
})
export class ElearningSharedResolver implements Resolve<void> {
  constructor(protected nodeSharedFacade: NodeSharedFacade) {
  }

  resolve() {
    return this.nodeSharedFacade.requestElearnings();
  }
}